import { z } from 'zod';
// Request and response schemas for the API layer
export const ListIntegratorsRequestDTOSchema = z.object({});
//# sourceMappingURL=list-integrators.dto.js.map